<template>
    <div id="app">
        <AppLayout>
            <HomeBanner />
            <GeneralDisclaimer />
            <router-view></router-view>
            <HomeFootnotes />
        </AppLayout>
        <!-- <CommonQuestions /> -->
        <!-- <TempMaintenance /> -->
    </div>
</template>

<script setup>
// import CommonQuestions from './components/CommonQuestions.vue'
import AppLayout from './components/AppLayout.vue'
import GeneralDisclaimer from './components/GeneralDisclaimer.vue'
import HomeFootnotes from './components/HomeFootnotes.vue'
import HomeBanner from './components/HomeBanner.vue'
// import TempMaintenance from './components/TempMaintenance.vue'

import { useHead } from '@vueuse/head'

useHead({
  title: "Toronto Fire Active Incidents",
  meta: [
    { name: 'description', content: 'Toronto Fire Active Incidents: Live map, dashboard, detailed analytics & data for firefighting enthusiasts.', id: 'desc' },
    { property: 'og:title', content: 'Toronto Fire Active Incidents' },
    { property: 'og:description', content: 'Live map, dashboard, detailed analytics & data for firefighting enthusiasts.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://torontofirefan.com' },
  ],
  link: [
    { rel: 'canonical', href: 'https://torontofirefan.com' }
  ]
})
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
</style>
